// Internal constants shared across app-shell helpers. Not part of the
// public API — keep imports inside the app-shell module.

/** Standard duration + easing for sider collapse/expand related animations
 *  (Brand wordmark width, WorkspaceSwitcher name+chevron fade, etc.).
 *  Matches AntD Sider's own 0.2s width transition. */
export const TRANSITION = '0.2s ease';
